export class RequestError extends Error {
  status?: number;
  data?: object;
  constructor(message: string, status?: number, data?: object) {
    super(message);
    this.status = status;
    this.data = data;
    Object.setPrototypeOf(this, RequestError.prototype);
  }
}